import React from 'react';
import { InfoText } from '../info-text';
import { useParams } from 'react-router-dom';

import { DownloadableReport } from './downloadable/report';
import { DownloadableCompetencies } from './downloadable/competencies';
import { useGetEventReportDetail } from '../../../hooks/services/use-reports';

export const AssessmentActivityReport: React.FC<{ eventName: string }> = ({
  eventName
}) => {
  const { eventId, detailId } = useParams();

  const { data } = useGetEventReportDetail({
    type: 'assessments',
    playlistId: detailId,
    eventId
  });

  return (
    <div>
      <span
        style={{
          fontWeight: 600
        }}>
        Assessment
      </span>
      <div
        style={{
          border: '1px solid #CFD4D9',
          borderRadius: '4px',
          padding: '22px 27px',
          display: 'flex',
          flexDirection: 'column',
          gap: '17px'
        }}>
        <div
          className={'d-flex'}
          style={{
            gap: '92px'
          }}>
          <InfoText
            heading={'Name'}
            text={data?.assessmentTemplateName ?? ''}
          />
          <InfoText heading={'Language'} text={data?.languages ?? ''} />
        </div>
        <div
          className={'d-flex'}
          style={{
            gap: '92px'
          }}>
          <InfoText heading={'Location'} text={data?.location ?? ''} />
          <InfoText heading={'Players'} text={data?.actualPlayers ?? ''} />
          <InfoText heading={'Teams'} text={data?.actualTeams ?? ''} />
          <InfoText heading={'Pax'} text={data?.pax ?? ''} />
        </div>

        <div
          style={{
            display: 'flex',
            gap: '24px'
          }}>
          <DownloadableReport />
          <DownloadableCompetencies
            amount={data?.totalCompetencies ?? 0}
            fileName={eventName}
          />
        </div>
      </div>
    </div>
  );
};
